// © 2026 AttainIP Engineering
/**
 * Focus management on route changes — WCAG 2.1 AA (2.4.3 Focus Order)
 *
 * After each route transition, moves focus to the #main-content element
 * so keyboard and screen-reader users start at the top of the new page.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useRouteFocus() {
  const { pathname } = useLocation();

  useEffect(() => {
    const main = document.getElementById('main-content');
    if (main) {
      // tabIndex=-1 allows programmatic focus without adding to tab order
      main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: false });
    }

    // Announce route change to screen readers
    window.scrollTo(0, 0);
  }, [pathname]);
}
